import { render, staticRenderFns } from "./AppInfoTextBlock.vue?vue&type=template&id=3d6b26dc&"
import script from "./AppInfoTextBlock.vue?vue&type=script&lang=js&"
export * from "./AppInfoTextBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports